import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { memo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import {
  commonState,
  setMobileMenuDrawerClose,
} from '../../../app/base/commonSlice';
import { themeStyle } from '../../../app/theme/themeSlice';
import useNotification from '../../../utils/hooks/useNotification';
import MobileMenuDrawer from './MobileMenuDrawer';
import MobileMenuItem from './MobileMenuItem';
import './styles.scss';
import { authState } from '../../../app/auth/authSlice';

function MobileMenu() {
  const {
    handleButtonClick,
    notificationData,
    notifications,
    fetchNextPage,
    hasMore,
    isLoading,
  } = useNotification();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const myBracTheme = useSelector(themeStyle);
  const mode = myBracTheme.mode === 'light';

  const { profile } = useSelector(authState);

  const { t } = useTranslation();

  const { mobileMenu } = useSelector(commonState);

  const mobileMenuData = [
    {
      icon: 'bell',
      title: `${t('mobile.notification')}`,
    },
    {
      icon: 'list',
      title: `${t('mobile.menu')}`,
    },
    {
      icon: 'house',
      title: `${t('mobile.home')}`,
    },
    {
      icon: 'person',
      title: `${t('mobile.user')}`,
    },
  ];

  const handleClick = useCallback(
    (type: string | undefined) => {
      if (type === 'Menu' || type === 'মেনু') {
        dispatch(
          setMobileMenuDrawerClose({
            isDrawerOpen: !mobileMenu?.isMobileMenuDrawerClose,
            menuKey: 'isMobileMenuDrawerClose',
          })
        );
      } else if (type === 'Notification' || type === 'নোটিফিকেশন') {
        handleButtonClick();
        dispatch(
          setMobileMenuDrawerClose({
            isDrawerOpen: !mobileMenu?.isMobileNotificationClose,
            menuKey: 'isMobileNotificationClose',
          })
        );
      } else if (type === 'User' || type === 'ইউজার') {
        dispatch(
          setMobileMenuDrawerClose({
            isDrawerOpen: !mobileMenu?.isMobileProfileClose,
            menuKey: 'isMobileProfileClose',
          })
        );
      } else if (type === 'Home' || type === 'হোম') {
        navigate('/');
        dispatch(
          setMobileMenuDrawerClose({
            isDrawerOpen: false,
            menuKey: 'isMobileHomeClose',
          })
        );
      }
    },
    [
      dispatch,
      handleButtonClick,
      mobileMenu?.isMobileMenuDrawerClose,
      mobileMenu?.isMobileNotificationClose,
      mobileMenu?.isMobileProfileClose,
      navigate,
    ]
  );

  const notificationCount =
    typeof notificationData?.results?.unread_count === 'number'
      ? notificationData?.results?.unread_count
      : profile?.user_settings?.unread_notification_count;

  return (
    <>
      <div
        className="mobile-menu-wrapper"
        style={{
          borderTop: mode ? '' : '1px solid #565657',
        }}
      >
        {mobileMenuData.map((item) => {
          return (
            <MobileMenuItem
              notificationBubble={
                (item?.title === 'Notification' ||
                  item?.title === 'নোটিফিকেশন') &&
                notificationCount > 0
              }
              key={item.title}
              title={item.title}
              icon={item.icon}
              onClick={handleClick}
            />
          );
        })}
      </div>
      <MobileMenuDrawer
        fetchNextPage={fetchNextPage}
        hasMore={hasMore}
        notificationData={notifications}
        isLoading={isLoading}
      />
    </>
  );
}

export default memo(MobileMenu);
